export default "__VITE_ASSET__19rGp9oq__"